 // API Configuration
 import { Config } from "../../Common/Config";
 import { clearAuthAndRedirect } from "../../Common/auth";
 const API_BASE_URL = Config.url;
 export const API_CONFIG = {
   baseUrl: API_BASE_URL,
   getAuthHeader: () => ({
     'Authorization': `Bearer ${localStorage.getItem('token')}`,
     'Content-Type': 'application/json',
   }),
   // This module uses fetch() rather than axios, so it isn't covered by the
   // app-wide axios response interceptor (src/index.js) that redirects to
   // login on an expired token — check for it here too.
   checkAuthResponse: (response) => {
     if (response.status === 401 && localStorage.getItem('token')) {
       clearAuthAndRedirect();
     }
   },
 };
 
 // Email Configurations API
 export const emailConfigApi = {
   // Fetch all email configurations
   async getAll() {
     const response = await fetch(`${API_CONFIG.baseUrl}email-configurations`, {
       method: 'GET',
       headers: API_CONFIG.getAuthHeader(),
     });
     
     API_CONFIG.checkAuthResponse(response);
     if (!response.ok) {
       throw new Error('Failed to fetch email configurations');
     }
     
     const data = await response.json();
     return data.data;
   },
 
   // Update email configuration by ID
  async update(id, payload) {
    const response = await fetch(`${API_CONFIG.baseUrl}email-configurations/${id}`, {
       method: 'PUT',
       headers: API_CONFIG.getAuthHeader(),
       body: JSON.stringify(payload),
     });
     
     API_CONFIG.checkAuthResponse(response);
     if (!response.ok) {
       throw new Error('Failed to update email configuration');
     }
     
     return response.json();
   },
 };
 
 // Shortcodes API
 let shortcodeCache = null;
 
 export const shortcodesApi = {
   async getAll() {
     if (shortcodeCache) {
       return shortcodeCache;
     }
     
     const response = await fetch(`${API_CONFIG.baseUrl}short-codes`, {
       method: 'GET',
       headers: API_CONFIG.getAuthHeader(),
     });
     
     API_CONFIG.checkAuthResponse(response);
     if (!response.ok) {
       throw new Error('Failed to fetch shortcodes');
     }
     
     const data = await response.json();
     shortcodeCache = data.data;
     return shortcodeCache;
   },
   
   clearCache() {
     shortcodeCache = null;
   },
 };